import { server_connection } from 'config';

export const GET_ALL_TABLE_SORTING   = '[TABLE SORT] GET ALL TABLE SORTING';
export const SET_TABLE_SORT          = '[TABLE SORT] SET TABLE SORT';
export const GET_ALL_TABLE_FILTERING = '[TABLE FILTER] GET ALL TABLE FILTERING';
export const SET_TABLE_FILTER        = '[TABLE FILTER] SET TABLE FILTER';
export const RESET_TABLE_FILTER      = '[TABLE FILTER] RESET TABLE FILTER'
export const SET_TABLE_PAGE_SIZE     = '[TABLE PAGE] GET TABLE PAGE SIZE'; 
export const GET_TABLE_PREFENCES     = '[TABLE PREF] GET TABLE PREFENCES';
export const CONVERT_SIDE_PANEL_FILTER_TO_PROPS = '[TABLE FILTER] CONVERT SIDE PANEL FILTER TO PROPS';

export function getUserTablePreferences(auth_id) {
    return (dispatch) => {
        fetch(server_connection + '/utility/table/preferences',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ auth_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_TABLE_PREFENCES,
                    payload: responseData
                })
            });
    }
}

export function setTableSort(auth_id, table_name, sort_list) {
    return (dispatch) => {
        fetch(server_connection + '/utility/table/set_sort',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ auth_id, table_name, sort_list })
            })
            .then((response) => {
                dispatch({
                    type: SET_TABLE_SORT,
                    payload: { table_name, sort_list },
                })
            })
    }
}

export function setTableFilter(auth_id, table_name, filter_list) {
    return (dispatch) => {
        fetch(server_connection + '/utility/table/set_filter',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ auth_id, table_name, filter_list })
            })
            .then((response) => {
                dispatch({
                    type: SET_TABLE_FILTER,
                    payload: { table_name, filter_list },
                })
            })
    }
}

export function convertSidePanelFilterToProps(table_name, filter_list) {
    return {
        type: CONVERT_SIDE_PANEL_FILTER_TO_PROPS,
        payload: {table_name, filter_list}
    }
}

export function resetTableFilter(auth_id, table_name) {
    return (dispatch) => {
        fetch(server_connection + '/utility/table/reset_filter',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ auth_id, table_name })
            })
            .then((response) => {
                dispatch({
                    type: RESET_TABLE_FILTER,
                    payload: { table_name },
                })
            })
    }
}

export function setTablePageSize(auth_id, table_name, page_size) {
    return (dispatch) => {
        fetch(server_connection + '/utility/table/set_page_size',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ auth_id, table_name, page_size })
            })
            .then((response) => {
                dispatch({
                    type: SET_TABLE_PAGE_SIZE,
                    payload: { table_name, page_size },
                })
            })
    }
}


// WEBPACK FOOTER //
// src/main/components/tableSort/store/actions/table_sort.actions.js